import { render } from "./myCounsel.vue?vue&type=template&id=6ec6c466&ts=true"
import script from "./myCounsel.vue?vue&type=script&lang=ts&config=true"
export * from "./myCounsel.vue?vue&type=script&lang=ts&config=true"

import "./myCounsel.vue?vue&type=style&index=0&id=6ec6c466&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__